<template>
    <v-btn v-bind="$attrs" :color="color" depressed small v-on="$listeners">
        <template #default>
            <slot></slot>
        </template>
    </v-btn>
</template>
<script>
export default {
    name: 'PlainBtn',
    props: {
        transparent: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        color() {
            return 'tgk-paragraph-text' + (this.transparent ? ' transparent' : '');
        },
    },
};
</script>
